"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ramda_1 = require("ramda");

var react_1 = __importDefault(require("react"));

var react_cookie_1 = require("react-cookie");

var utm_extractor_1 = require("utm-extractor");

exports.UtmCookieName = 'utm_entries';

function isDupeUtm(utmList, utm) {
  if (utmList.length === 0) {
    return false;
  }

  var utmKeys = Object.keys(utm).filter(function (key) {
    return key.startsWith('utm_');
  });
  var dupes = utmList.filter(function (existingUtm) {
    var matchedValues = utmKeys.map(function (key) {
      return existingUtm[key] === utm[key];
    });
    return matchedValues.every(function (value) {
      return value === true;
    });
  });
  return Boolean(dupes.length);
}

var UtmTracker =
/** @class */
function (_super) {
  __extends(UtmTracker, _super);

  function UtmTracker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  UtmTracker.recordUtmCodes = function (props) {
    var cookies = props.cookies;
    var querystring = ramda_1.pathOr('', ['location', 'search'], props);

    if (!querystring) {
      return;
    }

    var utmCookie = cookies.get(exports.UtmCookieName) || [];
    var utm = new utm_extractor_1.Utm(querystring);
    var utmMap = utm.get();

    if (!isDupeUtm(utmCookie, utmMap)) {
      utmMap.utm_created_at = new Date();
      utmCookie.push(utmMap);
    }

    if (!Boolean(utmCookie.length)) {
      return;
    }

    var options = {
      domain: undefined,
      path: '/'
    }; // temporary go-around for testing purposes

    var hostname = ramda_1.pathOr('', ['location', 'hostname'], props);

    if (hostname.includes('kindur.com')) {
      options.domain = '.kindur.com';
    }

    cookies.set(exports.UtmCookieName, utmCookie, options);
  };

  UtmTracker.prototype.componentDidMount = function () {
    UtmTracker.recordUtmCodes(this.props);
  };

  UtmTracker.prototype.render = function () {
    // tslint:disable-next-line:jsx-no-bind
    return react_1["default"].createElement(react_1["default"].Fragment, null, this.props.children);
  };

  return UtmTracker;
}(react_1["default"].Component);

exports["default"] = react_cookie_1.withCookies(UtmTracker);